import { Toast } from "components/toast";
import { UserLicensesEndpoints } from "../../utils";

export const parseISODate = (dateString: string): Date => {
  const [year, month, day] = dateString.split("-").map(Number);
  return new Date(year, month - 1, day);
};

export const startOfDay = (date: Date): Date =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate());

const minusMonths = (date: Date, months: number): Date => {
  const result = new Date(date);
  result.setMonth(result.getMonth() - months);
  return result;
};

const daysBetween = (startDate: Date, endDate: Date): number => {
  const MS_PER_DAY = 24 * 60 * 60 * 1000;
  return Math.floor(
    (startOfDay(endDate).getTime() - startOfDay(startDate).getTime()) /
      MS_PER_DAY
  );
};

const roundDown = (value: number, scale: number): number => {
  const factor = 10 ** scale;
  return Math.floor(value * factor) / factor;
};

export const calculateProportionalValue = (
  startDate: Date,
  expirationDate: Date,
  monthlyAmount: number
): number => {
  if (startOfDay(startDate).getTime() > startOfDay(expirationDate).getTime()) {
    throw new Error("startDate cannot be after expirationDate");
  }

  if (
    startOfDay(startDate).getTime() === startOfDay(expirationDate).getTime()
  ) {
    return 0;
  }

  const baseStartDate = minusMonths(expirationDate, 1);
  if (startOfDay(startDate).getTime() < startOfDay(baseStartDate).getTime()) {
    throw new Error(
      `startDate cannot be before ${baseStartDate.toISOString().split("T")[0]}`
    );
  }

  const baseDays = daysBetween(baseStartDate, expirationDate);
  const chargeableDays = daysBetween(startDate, expirationDate);

  const proportional = (chargeableDays * monthlyAmount) / baseDays;
  const scale5 = roundDown(proportional, 5);
  return roundDown(scale5, 2);
};

export const handleSaveUserLicence = async ({
  setIsLoading,
  customerId,
  targetMaster,
  targetVO,
  onUpdateLicenses,
  onClose,
  onSuccess
}: {
  setIsLoading?: (isLoading: boolean) => void;
  customerId: number;
  targetMaster: number;
  targetVO: number;
  onUpdateLicenses?: (data: any) => void;
  onClose?: () => void;
  onSuccess?: () => void;
}) => {
  setIsLoading?.(true);
  try {
    const data = await UserLicensesEndpoints.putLicense(customerId, {
      qtyLicenseMaster: targetMaster,
      qtyLicenseVendedorOrOperacional: targetVO
    });

    onUpdateLicenses?.(data);
    onClose?.();
    onSuccess?.();
  } catch (error: any) {
    const errorMessage =
      error?.data?.message === "sem_saldo"
        ? "Saldo insuficiente"
        : "Erro desconhecido";

    Toast({
      title: "Erro ao atualizar licença",
      description: errorMessage,
      status: "error"
    });
  } finally {
    setIsLoading?.(false);
  }
};
